export const PARTNER_APP_INTEGRATION_STATUSES = Object.freeze({
  ACTIVE: 'A',
  SUSPENDED: 'S',
  PAID: 'P',
  BLOCKED: 'B',
  DISABLED: 'D',
})

export const COMPANIES_WITH_DISABLED_BUTTON = [
  'Booksy Med',
]
